export const DEFAULT_FILTERS: IFilterValues = {
  index: {
    type_value: 'buy',
    rooms_value: ['1', '2'],
    building_type_value: ['flat'],
  },
  'daily-rent': {
    type_value: 'rent_short',
    rooms_value: ['1', '2'],
    building_type_value: ['flat'],
  },
  commercial: {
    type_value: 'rent_long',
    rooms_value: ['1', '2'],
    building_type_value: ['office'],
  },
  sale: {
    type_value: 'buy',
    rooms_value: ['1', '2'],
    building_type_value: ['flat'],
  },
  rent: {
    type_value: 'rent_long',
    rooms_value: ['1', '2'],
    building_type_value: ['flat'],
  },
  'new-buildings': {
    type_value: 'buy',
    rooms_value: [],
    building_type_value: ['flat'],
  },
};

export interface IFilterValues {
  [Identifier: string]: {
    type_value: string;
    rooms_value: string[];
    building_type_value: string[];
  };
}
